export enum DashboardDateRange {
  YESTERDAY = 'yesterday',
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
  ALL = 'all',
  CUSTOM = 'custom',
}
